import { LogOut } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useLogout, useSession } from '../hooks/useSession';
import { adminNav } from '../nav';
import { Button, Chip, PanelLayout, Sidebar, SidebarLogo, SpinnerBlock, Topbar } from '../ui';
import { Nav } from './Nav';

/**
 * Admin panel chrome. Same DOM skeleton as the user panel — one theme, two
 * sidebar configs (§6.2). The differences are branding, the nav config, and the
 * topbar actions.
 */
export function AppShell() {
  const { isLoading, isAuthenticated, session } = useSession();
  const logout = useLogout();
  const location = useLocation();

  if (isLoading) return <SpinnerBlock />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // The admin bundle is a separate deploy, but the server is still the
  // authority — a non-admin session gets nothing to render.
  if (session && !session.is_admin) {
    return <Navigate to="/login" replace />;
  }

  return (
    <PanelLayout
      sidebar={
        <Sidebar logo={<SidebarLogo title={'Alpha One\nAdmin Panel'} />}>
          <Nav groups={adminNav} />
        </Sidebar>
      }
      topbar={
        <Topbar
          actions={
            <>
              <Chip tone="warning">ADMIN</Chip>
              <Button
                variant="outline-gold"
                size="sm"
                leftIcon={<LogOut size={16} />}
                onClick={() => logout.mutate()}
                disabled={logout.isPending}
              >
                Logout
              </Button>
            </>
          }
        />
      }
    >
      <Outlet />
    </PanelLayout>
  );
}
